import { render } from "./VaIconSlower.vue?vue&type=template&id=5b830fde"
import script from "./VaIconSlower.vue?vue&type=script&lang=js"
export * from "./VaIconSlower.vue?vue&type=script&lang=js"

import "./VaIconSlower.vue?vue&type=style&index=0&id=5b830fde&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__